const ROOT_CLASSNAME = 'event-filters';
const EVENT_ROOT_CLASSNAME = 'all-events__event';
const eventFiltersWrapper = document.getElementById('js-' + ROOT_CLASSNAME);
const eventTypeFilters = document.querySelectorAll(`.${ROOT_CLASSNAME}__link--event-type`);
const festivalDayFilters = document.querySelectorAll(`.${ROOT_CLASSNAME}__link--festival-day`);
const allEventCards = document.querySelectorAll(`.${EVENT_ROOT_CLASSNAME}`);
const ALL_EVENTS = 'all-events';
const EVENT_FILTERS_KEY = 'eventFilters';
const DAY_FILTERS_KEY = 'eventFilters';
let selectedFilterArray = [];

const filterEvents = () => {
    if (!eventFiltersWrapper) {
        let pathName = window.location.pathname;
        pathName = pathName.includes('?') ? pathName.split('?')[0] : pathName;
        const url = window.location.protocol + "//" + window.location.host + pathName;
        window.history.replaceState({}, document.title, url);
        return;
    }

    onFilterLoad();

    eventTypeFilters.forEach((element) => {
        element.addEventListener('click', () => handleEventTypeFilterClick(element));
    });

    festivalDayFilters.forEach((element) => {
        element.addEventListener('click', () => handleFestivalDayFilterClick(element));
    });
};

const onFilterLoad = () => {
    const filtersFromStorage = window.sessionStorage.getItem(EVENT_FILTERS_KEY);
    selectedFilterArray = filtersFromStorage ? filtersFromStorage.split(',') : [];

    // Resets
    resetFilters('eventFilters');
    resetEventCards(allEventCards);

    // If no filters
    isLastFilter();

    // Update Href
    updateHref();

    // Add classes
    addClassesToFilters();
};

const handleEventTypeFilterClick = (element) => {
    const slug = element.dataset.slug;

    // Resets
    resetFilters('eventFilters');
    resetEventCards(allEventCards);

    // Process selected filter
    processSelectedFilter(slug);

    // If we remove everything then we want to select all-events
    isLastFilter();

    // Update Href
    updateHref();

    // Update Stored Filters
    updateStoredFilters();

    // Add classes
    addClassesToFilters();
};

const isLastFilter = () => {
    if (selectedFilterArray.length === 0) {
        // If "all events" selected then we want to overwrite all items
        selectedFilterArray = [ALL_EVENTS];
    }
};

const processSelectedFilter = (filterSlug) => {
    if (selectedFilterArray.includes(filterSlug)) {
        // Delete from selected array if it exists
        selectedFilterArray = selectedFilterArray.filter(item => item !== filterSlug);
    } else if (filterSlug === ALL_EVENTS) {
        // If "all events" selected then we want to overwrite all items
        selectedFilterArray = [ALL_EVENTS];
    } else {
        // Add clicked element to selected array if doesn't exist and remove "all-events"
        selectedFilterArray = selectedFilterArray.filter(item => item !== ALL_EVENTS);
        selectedFilterArray.push(filterSlug);
    }
};

const updateHref = () => {
    const url = window.location.protocol + "//" + window.location.host + window.location.pathname + '?filters=' + selectedFilterArray.join(',');
    window.history.pushState({path: url}, '', url);
};

const updateStoredFilters = () => {
    window.sessionStorage.setItem(EVENT_FILTERS_KEY, selectedFilterArray.join(','));
};

const addClassesToFilters = () => {
    // Add is active to every filter in selectedFilterArray
    selectedFilterArray.forEach(filterItem => {
        const filter = document.querySelector(`.event-filter--${filterItem}`);
        const eventCards = document.querySelectorAll(`.event-type--${filterItem}`);
        filter.classList.add(`${ROOT_CLASSNAME}__link--is-active`);

        if (filterItem !== ALL_EVENTS) {
            // If "all-events" is not selected then show all eventCards for filter
            eventCards.forEach(eventCard => {
                if (eventCard) {
                    eventCard.classList.remove(`${EVENT_ROOT_CLASSNAME}--is-hidden`);
                }
            });
        } else {
            // Else show all eventCards
            allEventCards.forEach(eventCard => {
                if (eventCard) {
                    eventCard.classList.remove(`${EVENT_ROOT_CLASSNAME}--is-hidden`);
                }
            });
        }
    });
};

const resetFilters = (type) => {
    if (type === 'eventFilters') {
        return eventTypeFilters.forEach((filter) => {
            filter.classList.remove(`${ROOT_CLASSNAME}__link--is-active`);
        });
    }

    if (type === 'dayFilters') {
        return festivalDayFilters.forEach((filter) => {
            filter.classList.remove(`${ROOT_CLASSNAME}__link--is-active`);
        });
    }
};

const resetEventCards = (eventElements) => {
    eventElements.forEach((event) => {
        event.classList.add(`${EVENT_ROOT_CLASSNAME}--is-hidden`);
    })
};

const handleFestivalDayFilterClick = (element) => {
    console.log('&& Element clicked', element);
};

export default filterEvents;

